export enum AppRoutesEnum {
    BASE = '',

    DASHBOARD = '/dashboard',
    LOGIN = '/login',

    MANAGE_PICKUPS = '/manage-pickups',

    SCHEDULE_PICKUP = '/schedule-pickup',

    SCHEDULE_PICKUP_TIME = 'schedule-pickup/pickup-time',

    SCHEDULE_PICKUP_DETAILS = 'schedule-pickup/pickup-details',

    SCHEDULE_PICKUP_CONFIRMATION = 'schedule-pickup/pickup-confirmation',

    WELLPLATE_OVERPACK = '/wellplate-overpack',
    WELLPLATE_OVERPACK_STEP_ONE = '/wellplate-overpack/step-one',
    WELLPLATE_OVERPACK_STEP_TWO = '/wellplate-overpack/step-two',
    WELLPLATE_OVERPACK_STEP_THREE = '/wellplate-overpack/step-three',
}
